import { Routes } from '@angular/router';
import { checkInfoGuard } from './_core/_guards/check-info.guard';
import { authGuard } from './_core/_guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./private/private').then((c) => c.Private),
    canActivate: [authGuard],
    loadChildren: () =>
      import('./private/private.routes').then((c) => c.routes),
  },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  {
    path: '**',
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(
        (c) => c.PageNotFoundComponent,
      ),
  },
];
